var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"manager-title"},[_c('div',[_vm._v(" "+_vm._s(_vm.$t("FARES.STANDARD.TITLE_ADD_2"))+" "),_c('hr',{staticClass:"manager-title-sub"})])]),_c('FaresStandardEdit',{attrs:{"fare-standard-id":-1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }